export default "__VITE_ASSET__qTt0RmDh__"